import React, { Fragment } from 'react';
import classNames from 'classnames';
import './Course.less';

import Picture from '../../../../../components/picture/Picture';
import { FlagUI } from './CourseNewItem';
import { formatMoney, digitFormat } from '../../../../../lib/utils/UtilsFormatter';
import { isAndroid } from '../../../../../lib/utils/UtilsEnvi';

/**
 * 可选参数
 */
interface IProps {
	data: any;
	className?: string;
	isFlag?: boolean;
	isHome?: boolean;
	onClick?: any;
	getJumpUrl: (data: any) => string;
}

/**
 * 通用课程列表项
 */

export default class CommonCourseItem extends React.Component<IProps> {
	get isWeapp(): boolean {
		return typeof window !== 'undefined' && window.__wxjs_environment === 'miniprogram';
	}

	get flagStr(): string {
		const flag: any = this.props.data.flag;

		switch (flag) {
			case 'normal':
				return '';
			case 'boutique':
				return '精品';
			case 'recommend':
				return '热推';
			case 'surge':
				return '飙升';
			case 'star':
				return '大咖';
			default:
				return flag;
		}
	}

	/**
	 * 渲染
	 */
	public render(): any {
		let { data, onClick, className, isFlag = false, isHome = false, getJumpUrl } = this.props;

		let isDashi: boolean = data.regionType === 'master';
		let isCamp: boolean = data.regionType === 'camp';

		className = classNames('common-course-item', className, {
			'type-dashi': isDashi,
		});

		let avatarUrl: string = data.logo || data.headImage || data.headImageUrl;
		let w: number;
		let h: number;
		if (isDashi) {
			w = 160;
			h = 205;
		} else {
			w = 240;
			h = 148;
		}

		return (
			<a className={className} href={getJumpUrl(data)}>
				<div className="img-wrap">
					<div className={classNames('poster', `flag-${data.flag}`)}>
						<div className="c-abs-pic-wrap">
							<Picture
								src={avatarUrl}
								placeholder={true}
								resize={{
									w,
									h,
								}}
							/>
						</div>
					</div>
					{isCamp ? <div className="learn-num">{data.flag}</div> : data.imgDesc ? <div className="learn-num">{data.imgDesc}</div> : <div className="learn-num">{digitFormat(data.learningNum || data.authNum || 0)}次学习</div>}
					{/*<FlagUI flag={ "独家" } />*/}
					{!!data.flag2 && isFlag && <FlagUI flag={data.flag2} />}
				</div>

				<div className="info">
					<div className="c-flex-grow1">
						<div className="name">
							{this.flagStr && <span className="hottest">{this.flagStr}</span>}
							{data.businessName}
						</div>
						{isDashi ? (
							<Fragment>
								{data.remark && <div className="remark">{data.remark}</div>}
								<div className="live-name">{data.liveName}</div>
							</Fragment>
						) : (
							<div className="remark">{data.remark || data.liveName}</div>
						)}
					</div>
					<div className="other-info">
						<p>
							{isDashi && <span className="learn-num">{data.learningNum ? `${digitFormat(data.learningNum)}次学习 | ` : '0次学习 | '}</span>}
							{data.businessType === 'channel' ? <span>{data.planCount || data.topicNum || 0}课</span> : data.businessType === 'topic' ? <span>单课</span> : false}
						</p>

						{data.money > 0 ? (
							(!isAndroid() && this.isWeapp) || !this.isWeapp ? (
								<div className="price">
									{data.discount === -1 || (data.discountStatus === 'K' && data.shareCutStartTime > data.currentTime && data.shareCutEndTime < data.currentTime) ? (
										<span className="current">￥{formatMoney(data.money)}</span>
									) : (
										<span>
											<span className="origin">¥{formatMoney(data.money)}</span>
											<span className="current">¥{formatMoney(data.discount)}</span>
										</span>
									)}
								</div>
							) : null
						) : (
							<div className="price">
								<div className="free">免费</div>
							</div>
						)}
					</div>
				</div>
			</a>
		);
	}
}

/**
 * 占位
 */
export function CommonCourseItemPlaceholder(): any {
	return (
		<div className="common-course-item placeholder">
			<div className="img-wrap"></div>
			<div className="info">
				<div>
					<div className="name"></div>
					<div className="remark"></div>
					<div className="live-name"></div>
				</div>
				<div className="other-info">
					<p></p>
					<div className="price"></div>
				</div>
			</div>
		</div>
	);
}
